module.exports = __webpack_public_path__ + "img/crime-victim-assist.d02cdab9.png";